import { render, staticRenderFns } from "./404.vue?vue&type=template&id=62d3e5ae&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=62d3e5ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d3e5ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d3e5ae')) {
      api.createRecord('62d3e5ae', component.options)
    } else {
      api.reload('62d3e5ae', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=62d3e5ae&scoped=true", function () {
      api.rerender('62d3e5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/layout/404.vue"
export default component.exports